const ActionTypes = {
  SET_LOADING: 'SET_LOADING',

  // APIs
  GENERATE_TOKEN: "GENERATE_TOKEN",

  SET_USER_LOGGED_IN: "SET_USER_LOGGED_IN",
  SET_AUTH_CODE_SEARCH: "SET_AUTH_CODE_SEARCH",
  SET_USER_DATA: "SET_USER_DATA",

  SET_LOADING_DATA: "SET_LOADING_DATA",

  SET_API_ERROR: "SET_API_ERROR",
  POST_LOGGER: "POST_LOGGER",

  SET_SELECTED_TAB: "SET_SELECTED_TAB",
  SET_PROGRAM_NAME: "SET_PROGRAM_NAME",

  SET_DASHBOARD_LOADING: "SET_DASHBOARD_LOADING",
  SET_PROJECT_NAME: "SET_PROJECT_NAME",

  SELECTED_ACCOUNTING_MONTH: 'SELECTED_ACCOUNTING_MONTH',

  SGP_SET_REPORT_NAME: "SGP_SET_REPORT_NAME",
  SGP_SET_REPORT_FILTER: "SGP_SET_REPORT_FILTER",
  SGP_SET_REPORT_FILTER_DURATION: "SGP_SET_REPORT_FILTER_DURATION",

  GET_STARHUB_REPORT_COUNT: "GET_STARHUB_REPORT_COUNT",
  GET_STARHUB_REPORT_COUNT_SUCCESS: "GET_STARHUB_REPORT_COUNT_SUCCESS",
  GET_STARHUB_REPORT_COUNT_FAILURE: "GET_STARHUB_REPORT_COUNT_FAILURE",

  GET_STARHUB_REPORT_COUNT_DETAILS: "GET_STARHUB_REPORT_COUNT_DETAILS",
  GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS: "GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS",
  GET_STARHUB_REPORT_COUNT_DETAILS_FAILURE: "GET_STARHUB_REPORT_COUNT_DETAILS_FAILURE",

  GET_STARHUB_REPORT_DETAILS: "GET_STARHUB_REPORT_DETAILS",
  GET_STARHUB_REPORT_DETAILS_SUCCESS: "GET_STARHUB_REPORT_DETAILS_SUCCESS",
  GET_STARHUB_REPORT_DETAILS_FAILURE: "GET_STARHUB_REPORT_DETAILS_FAILURE",

  HIDE_DATE_FILTER: "HIDE_DATE_FILTER",
  SET_USER_DETAILS: "SET_USER_DETAILS",

  GET_CHART_COUNT_DATA: "GET_CHART_COUNT_DATA",
  GET_CHART_COUNT_DATA_SUCCESS: "GET_CHART_COUNT_DATA_SUCCESS",
  GET_CHART_COUNT_DATA_FAILURE: "GET_CHART_COUNT_DATA_FAILURE",
  SET_EMAIL_ADDRESS: "SET_EMAIL_ADDRESS",
  SET_PASSWORD: "SET_PASSWORD",
  GET_SLA_REPORTS_DETAILS: "GET_SLA_REPORTS_DETAILS",
  GET_SLA_REPORTS_DETAILS_SUCCESS: "GET_SLA_REPORTS_DETAILS_SUCCESS",
  GET_SLA_REPORTS_DETAILS_FAILURE: "GET_SLA_REPORTS_DETAILS_FAILURE",
  SET_PROJECT_SUB_MENU: "SET_PROJECT_SUB_MENU",
  SGP_SET_DOWNLOAD_REPORT_DURATION_LABEL: "SGP_SET_DOWNLOAD_REPORT_DURATION_LABEL",
  SGP_SET_DOWNLOAD_REPORT_DURATION: "SGP_SET_DOWNLOAD_REPORT_DURATION",
  SGP_DOWNLOAD_REPORT: "SGP_DOWNLOAD_REPORT",
  VERIFY_OTP_REQUEST: "VERIFY_OTP_REQUEST",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  SIGNOUT_REQUEST: "SIGNOUT_REQUEST",
  SET_THEME_DATA: "SET_THEME_DATA",
  GET_USER_DETAILS: "GET_USER_DETAILS",
  GET_CELCOM_FIANANCE_DETAILS: "GET_CELCOM_FIANANCE_DETAILS",
  GET_CELCOM_CUSTOMER_VALUE_MGMT_DETAILS: "GET_CELCOM_CUSTOMER_VALUE_MGMT_DETAILS",
  SET_CELCOM_CUSTOMER_VALUE_MGMT_DATA: "SET_CELCOM_CUSTOMER_VALUE_MGMT_DATA",
  UPLOAD_FIANANCE_REPORT: "UPLOAD_FIANANCE_REPORT",
  GET_FIANANCE_REPORTS_DETAILS: "GET_FIANANCE_REPORTS_DETAILS",
  ADD_REBATE: "ADD_REBATE",
  GET_MONTHWISE_REBATE: "GET_MONTHWISE_REBATE",
  GET_SALES_BUSINESS_REPORT: "GET_SALES_BUSINESS_REPORT",
  SET_HEADER_TITLE: "SET_HEADER_TITLE",
  SALES_REPORT_MONTHLY_TREND_DATA: "SALES_REPORT_MONTHLY_TREND_DATA",
  SALES_REPORT_BUSINESS_DATA: "SALES_REPORT_BUSINESS_DATA",
  SEND_OTP : "SEND_OTP",
  UPDATE_FORGOT_PASSWORD : "UPDATE_FORGOT_PASSWORD"
};

export default ActionTypes;